import { render, staticRenderFns } from "./TalkAskExperience.vue?vue&type=template&id=78a7966a&scoped=true&"
import script from "./TalkAskExperience.vue?vue&type=script&lang=ts&"
export * from "./TalkAskExperience.vue?vue&type=script&lang=ts&"
import style0 from "./TalkAskExperience.vue?vue&type=style&index=0&id=78a7966a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a7966a",
  null
  
)

export default component.exports